import { render } from "./componentRadio.vue?vue&type=template&id=605a78a0"
import script from "./componentRadio.vue?vue&type=script&lang=js"
export * from "./componentRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__